import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
} from '@angular/core';
import { SelectRowService } from '../select-row.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { StopPropagationDirective } from 'angular-directives/stop-propagation.directive';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'td[eurogard-checkbox-cell]',
  templateUrl: './checkbox-cell.component.html',
  styleUrls: [ './checkbox-cell.component.scss' ],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    MatCheckboxModule,
    StopPropagationDirective,
  ],
})
export class CheckboxCellComponent<Data extends Record<string, any>> {

  @Input({ required: true })
  public element!: Data;

  constructor(
    @Inject(SelectRowService)
    public readonly selectRow: SelectRowService<Data>,
  ) {
  }

}
